import { useEffect } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { usePRD5040_R01Store } from "./Store_PRD5040_R01";
import { Content_PRD5040_R01 } from "./Content_PRD5040_R01";
import { SearchSection_PRD5040_R01 } from "./SearchSection_PRD5040_R01";
import { Chart_PRD5040_R01 } from "./Chart_PRD5040_R01";
import { Table_PRD5040_R01 } from "./Table_PRD5040_R01";

/**
 * PRD5040_R01 양품율 조회 컨테이너
 * 상단: 콤보차트 / 하단: 월별 피벗 테이블
 */
export const Container_PRD5040_R01 = () => {
	// 스토어에서 조회 결과 리스트와 초기화 함수를 가져옴
	const { PRD5040_R01List, initData } = usePRD5040_R01Store();
	// 하단 Message 컴포넌트에 표시할 메시지 세터
	const { setMessage } = useUiuxStore();
	// 공정 드롭다운 목록과, 없을 경우 불러오는 함수
	const { workPlaceList, fetchWorkPlaceCdCode } = useCommonCodeStore();

	// 공정(workPlaceList)은 공통코드 일괄 로드 묶음에 없으므로, 비어 있으면 별도 호출
	useEffect(() => {
		if (workPlaceList.length === 0) {
			fetchWorkPlaceCdCode().then(r => {}); // 공정 코드 목록을 별도로 조회
		}
	}, [workPlaceList.length, fetchWorkPlaceCdCode]);

	// 조회 로직 훅에서 fetchData 함수만 추출
	const { fetchData } = Content_PRD5040_R01({ setMessage });

	return (
		<div className="content-container">
			{/* 상단 액션바 (조회/저장/삭제/초기화/엑셀/인쇄 버튼) */}
			<Actionbar
				onFetchClick={fetchData}      // 조회 버튼 클릭 시 실행
				onSaveClick={undefined}       // 저장 기능 없음(조회 전용 화면)
				onDeleteClick={() => {}}      // 삭제 기능 없음(조회 전용 화면)
				onInitClick={initData}        // 초기화 버튼 클릭 시 실행
				onExcelClick={() => {}}       // 엑셀 기능 미구현
				onPrintClick={() => {}}       // 인쇄 기능 미구현
			/>

			{/* 검색조건 영역 */}
			<SearchSection_PRD5040_R01 />

			<div className="flex-1 flex flex-col min-h-0 px-[12px] py-[5px] gap-[10px] overflow-auto">
				{/* 콤보차트 영역 */}
				<div className="w-full shrink-0">
					<Chart_PRD5040_R01 data={PRD5040_R01List} />
				</div>
				{/* 월별 피벗 테이블 영역 */}
				<div className="w-full shrink-0">
					<Table_PRD5040_R01 data={PRD5040_R01List} />
				</div>
			</div>

			{/* 하단 안내/결과 메시지 표시 컴포넌트 */}
			<Message />
		</div>
	);
};

export default Container_PRD5040_R01;
